import { render, staticRenderFns } from "./DialogDeleteCustomer.vue?vue&type=template&id=17f1b316"
import script from "./DialogDeleteCustomer.vue?vue&type=script&lang=js"
export * from "./DialogDeleteCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports